<script setup>
import { watch } from 'vue';

import ExpandTransition from '@/components/ui/animations/ExpandTransition';
import OverlayTransition from '@/components/ui/animations/OverlayTransition';
import MenuIcon from '@/components/ui/icons/MenuIcon';
import { useVisibility } from '@/composables/useVisibility';

import Menu from './Menu.vue';

const { visible, toggleVisibility, hide } = useVisibility();
const body = document.getElementsByTagName('body')[0];
const html = document.getElementsByTagName('html')[0];

watch(
  () => visible.value,
  (newVal) => {
    if (newVal) {
      body.classList.add('hidden');
      html.classList.add('hidden');
    } else {
      body.classList.remove('hidden');
      html.classList.remove('hidden');
    }
  },
);
</script>

<template>
  <nav>
    <ul class="header-menu">
      <li class="header-menu__item">
        <button
          class="header-menu__button"
          @click="toggleVisibility"
        >
          <MenuIcon />
        </button>
      </li>
    </ul>
  </nav>

  <OverlayTransition
    :visible="visible"
    :delay="500"
    @click="hide"
  />
  <ExpandTransition :visible="visible">
    <Menu
      v-show="visible"
      ref="headerMenu"
      class="menu"
      @hide-menu="hide"
    />
  </ExpandTransition>
</template>

<style lang="scss" scoped>
.header {
  &-menu {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 31px;

    .item {
    }

    &__button {
      display: flex;
      background-color: transparent;
    }
  }
}

.menu {
  position: fixed;
  z-index: 99;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: var(--wp-surface-default);
}
</style>
